export default __webpack_public_path__ + "static/media/Woocommerce-23.b388e821.svg";